// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React, { useState } from 'react';

const ClinicasPorMes = ({ dados, loading, onFiltrar }) => {
    const hoje = new Date();
    const [mesSelecionado, setMesSelecionado] = useState(
        `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`
    );

    const handleFiltrar = () => {
        if (onFiltrar && mesSelecionado) {
            const [ano, mes] = mesSelecionado.split('-');
            onFiltrar(parseInt(ano), parseInt(mes) - 1);
        }
    };

    const formatarMoeda = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };

    return (
        <div className="table-card">
            <div className="table-header">
                <div>
                    <h3 className="table-title">Clínicas por Mês</h3>
                </div>
                <div className="dashboard-filters" style={{ marginTop: '0', padding: '0', border: 'none', background: 'transparent' }}>
                    <div className="filter-group" style={{ marginBottom: '0' }}>
                        <label className="filter-label">Selecionar Mês e Ano</label>
                        <input
                            type="month"
                            className="filter-input"
                            value={mesSelecionado}
                            onChange={(e) => setMesSelecionado(e.target.value)}
                            style={{ minWidth: '200px' }}
                        />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                        <button
                            className="period-btn active"
                            onClick={handleFiltrar}
                            disabled={loading}
                            style={{ 
                                minWidth: '120px',
                                height: '42px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px'
                            }}
                        >
                            {loading ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    Filtrando...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-filter"></i>
                                    Filtrar
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {loading && (
                <div className="skeleton-card" style={{ marginTop: '24px' }}>
                    <div className="skeleton-line long"></div>
                    <div className="skeleton-line long"></div>
                    <div className="skeleton-line medium"></div>
                </div>
            )}

            {!loading && (!dados || !dados.clinicas || dados.clinicas.length === 0) && (
                <div className="empty-state" style={{ marginTop: '24px' }}>
                    <div className="empty-state-icon">
                        <i className="fas fa-hospital"></i>
                    </div>
                    <p className="empty-state-title">Nenhuma clínica encontrada</p>
                    <p className="empty-state-text">
                        {dados ? 'Não há mensagens enviadas no mês selecionado' : 'Selecione um mês e clique em Filtrar para buscar as estatísticas'}
                    </p>
                </div>
            )}

            {!loading && dados && dados.clinicas && dados.clinicas.length > 0 && (
                <>
                    <div style={{ marginTop: '24px', marginBottom: '20px', padding: '16px', background: '#F9FAFB', borderRadius: '8px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                            <div>
                                <p className="text-muted" style={{ margin: '0', fontSize: '14px', marginBottom: '4px' }}>
                                    {dados.mesNome} - {dados.clinicas.length} {dados.clinicas.length === 1 ? 'clínica' : 'clínicas'}
                                </p>
                            </div>
                            <div style={{ textAlign: 'right' }}>
                                <div style={{ fontSize: '12px', color: '#6B7280', marginBottom: '4px' }}>Total Geral</div>
                                <div style={{ fontSize: '20px', fontWeight: '700', color: '#111827' }}>
                                    {dados.totalGeral.toLocaleString('pt-BR')} mensagens
                                </div>
                                <div style={{ fontSize: '16px', fontWeight: '600', color: '#6366F1', marginTop: '4px' }}>
                                    {formatarMoeda(dados.valorTotalGeral)}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ overflowX: 'auto' }}>
                        <table className="modern-table">
                            <thead>
                                <tr>
                                    <th>Clínica</th>
                                    <th style={{ textAlign: 'right' }}>Quantidade</th>
                                    <th style={{ textAlign: 'right' }}>Valor Unitário</th>
                                    <th style={{ textAlign: 'right' }}>Valor Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dados.clinicas.map((clinica, index) => (
                                    <tr key={clinica.idClinica || index}>
                                        <td>
                                            <strong>{clinica.nome || clinica.idClinica}</strong>
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <span className="status-badge other">
                                                {clinica.quantidade.toLocaleString('pt-BR')}
                                            </span>
                                        </td>
                                        <td style={{ textAlign: 'right', color: '#6B7280' }}>
                                            {formatarMoeda(clinica.valorUnitario)}
                                        </td>
                                        <td style={{ textAlign: 'right' }}>
                                            <strong style={{ color: '#6366F1' }}>
                                                {formatarMoeda(clinica.valorTotal)}
                                            </strong>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr style={{ backgroundColor: '#F9FAFB', fontWeight: '600' }}>
                                    <td>
                                        <strong>Total</strong>
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        <span className="status-badge other">
                                            {dados.totalGeral.toLocaleString('pt-BR')}
                                        </span>
                                    </td>
                                    <td style={{ textAlign: 'right', color: '#6B7280' }}>
                                        {formatarMoeda(0.14)}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        <strong style={{ color: '#6366F1', fontSize: '16px' }}>
                                            {formatarMoeda(dados.valorTotalGeral)}
                                        </strong>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </>
            )}
        </div>
    );
};

export default ClinicasPorMes;
